exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.offline-alert[data-v-94cab83e] {\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    background-color: #b0bec5 !important;\n    z-index: 4 !important;\n}\n.message[data-v-94cab83e] {\n    color: rgba(0, 0, 0, 0.5) !important;\n}\n", ""]);

